export const COLLAPSE_SIDER = 'COLLAPSE_SIDER';
export const EXPAND_SIDER = 'EXPAND_SIDER';
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const DELETE_ROWS = 'DELETE_ROWS';
export const CUT_ROWS = 'CUT_ROWS';
export const COPY_ROWS = 'COPY_ROWS';
export const ADD_ROW_ABOVE = 'ADD_ROW_ABOVE';
export const ADD_ROW_BELOW = 'ADD_ROW_BELOW';
export const PASTE_AT_BOTTOM = 'PASTE_AT_BOTTOM';
export const PASTE_AFTER_ROW = 'PASTE_AFTER_ROW';
export const UPDATE_ROW = 'UPDATE_ROW';
export const CANCEL_ROW_ADD = 'CANCEL_ROW_ADD';
export const UPDATE_CELLS = 'UPDATE_CELLS';
export const CANCEL_CELLS_UPDATE = 'CANCEL_CELLS_UPDATE';
export const CANCEL_BULK_ACTION = 'CANCEL_BULK_ACTION';
export const UPDATE_MASTER_LIST_ID = 'UPDATE_MASTER_LIST_ID';
